<template>
	<div>
		<v-dialog v-model="dialog_linked_accounts" no-click-animation scrollable persistent transition="slide-y-transition">
	      <v-card>
	        <v-card-text nopadding>
	        	
	        	<v-list nopadding>
	        		<div v-for="(item, index) in linkedAccounts" :key="index">
	        			<v-list-tile @click="getLinkedAccountDetails(item)">
				            <v-list-tile-title>{{item.accountName}}</v-list-tile-title>
			        	</v-list-tile>
			        	<v-divider v-if="linkedAccounts.length-1 != index"></v-divider>	
	        		</div>
		        </v-list>

	        </v-card-text>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['linkedAccounts', 'getLinkedAccountDetails'],
		data(){
			return{
				dialog_linked_accounts: false
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_linked_accounts = true;
			},
			closeDialogWeb: function () {
				this.dialog_linked_accounts = false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/newreports/dialogs/dialog_linked_accounts.vue